import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';
import { ONE_WEEK } from './time-frames';

export const InPastWeekMatcher: FieldMatcher = {
  name: 'inPastWeek',
  displayName: 'Within last week',
  options: {
    setValue: (): string => Date.now().toString(),
    chipFormatter: (value: string): string =>
      `since last ${new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(new Date(Number(value) - ONE_WEEK))}`,
  },
};